import React, { FC } from 'react'

import { clsx } from 'clsx'
import type { SlotProps } from 'input-otp'

export interface OtpSlotsProps {
  slots: SlotProps[]
}

const OtpSlotCell: FC<{ slot: SlotProps }> = ({ slot }) => (
  <div className={clsx('user-profile-login__otp-slot', slot.isActive && 'user-profile-login__otp-slot_active')}>
    {slot.char || slot.placeholderChar || ''}
    {slot.hasFakeCaret ? <span aria-hidden className="user-profile-login__otp-caret" /> : null}
  </div>
)

export const OtpSlots: FC<OtpSlotsProps> = ({ slots }) => (
  <>
    <div className="user-profile-login__otp-group">
      {slots.slice(0, 3).map((slot, idx) => (
        <OtpSlotCell key={`otp-left-${idx}`} slot={slot} />
      ))}
    </div>

    <span aria-hidden className="user-profile-login__otp-divider">
      —
    </span>

    <div className="user-profile-login__otp-group">
      {slots.slice(3).map((slot, idx) => (
        <OtpSlotCell key={`otp-right-${idx}`} slot={slot} />
      ))}
    </div>
  </>
)
